import React, { memo } from 'react'
import { faCoinFront } from '@fortawesome/pro-duotone-svg-icons'
import { Box, Stack } from '@mui/material'

import Text from '../text/Text'
import FaIcon from '../faIcon/FaIcon'
import BalanceCountDown from './BalanceCountDown'

const BalanceWithAnimation = ({
  t,
  symbol,
  previousUserPoints,
  currentUserPoints
}) => {
  const mediaQuery = 'sm'
  return (
    <Stack
      spacing={1}
      direction='row'
      alignItems='center'
      sx={{
        color: 'var(--layout-nav-text-primary-color)',
        bgcolor: 'background.neutral',
        borderRadius: 2,
        px: 2,
        py: 1,
        gap: { xs: 0.5, [mediaQuery]: 1 }
      }}
    >
      <Box color='primary.main'>
        <FaIcon icon={faCoinFront} size='lg' />
      </Box>
      <Text
        variant='subtitle2'
        label={
          <>
            <Text
              variant='subtitle2'
              label={t('wallet.balance')}
              sx={{ display: { xs: 'none', sm: 'block' } }}
              component='span'
            />
            <BalanceCountDown
              prev={previousUserPoints}
              current={currentUserPoints}
            />
            {symbol}
          </>
        }
        sx={{ display: 'flex', gap: 0.6 }}
      />
    </Stack>
  )
}

export default memo(BalanceWithAnimation)
